import React from "react";
import {
  FilterSection,
  ActiveFilterPills,
  UserProfilesTable,
  UserProfilesPagination,
  useUserProfiles,
} from "../../components/UserProfiles";

const PROFILE_URL = "https://naseebi.com/en/home/profiledetail";

export default function UserProfiles() {
  const {
    filters,
    handleFilterChange,
    clearFilters,
    removeFilter,
    getFilterLabel,
    getActiveFiltersCount,
    activeFilterEntries,
    primaryFields,
    secondaryFields,
    users,
    total,
    isLoading,
    backendPage,
    setBackendPage,
    backendLimit,
  } = useUserProfiles();

  const handleApply = () => {
    setBackendPage(1);
  };

  const handleViewProfile = (id) => {
    window.open(`${PROFILE_URL}/${id}`, "_blank");
  };

  return (
    <div className="p-4 w-full">
      <div className="bg-white rounded-xl shadow-xl p-6">
        <div className="flex justify-between items-center mb-3">
          <h3 className="text-md md:text-xl font-bold text-gray-800">
            User Profiles
          </h3>
          {getActiveFiltersCount() > 0 && (
            <button
              type="button"
              onClick={clearFilters}
              className="text-xs md:text-sm text-red-600 hover:text-red-700 font-medium">
              Clear All Filters
            </button>
          )}
        </div>

        <ActiveFilterPills
          activeKeys={activeFilterEntries}
          filters={filters}
          getLabel={getFilterLabel}
          onRemove={removeFilter}
        />

        <FilterSection
          primaryFields={primaryFields}
          secondaryFields={secondaryFields}
          values={filters}
          onChange={handleFilterChange}
          onApply={handleApply}
          onClear={clearFilters}
          applyLabel="Apply"
          clearLabel="Clear All"
        />

        <UserProfilesTable
          users={users}
          page={backendPage}
          limit={backendLimit}
          isLoading={isLoading}
          activeFiltersCount={getActiveFiltersCount()}
          onViewProfile={handleViewProfile}
        />

        {total > 0 && (
          <UserProfilesPagination
            page={backendPage}
            total={total}
            limit={backendLimit}
            onPageChange={setBackendPage}
          />
        )}
      </div>
    </div>
  );
}
